module.exports = __webpack_public_path__ + "img/logo-devto.8721f0de.svg";